import React from 'react'

import L from 'leaflet'

import {
  Map,
  TileLayer,
  ScaleControl,
  ZoomControl,
  LayerGroup
} from 'react-leaflet'

import Control from 'react-leaflet-control'

import 'leaflet/dist/leaflet.css'

import './styles.scss'

import { sections, sectionMembers, institutions } from 'lib/institutions'
import { cssColors as colors } from 'lib/colors'

import MapItem from './mapItem'

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default class LeafletMap extends React.Component {
  startViewport = null

  constructor(props) {
    super(props)
    this.state = {
      isMobile: window.innerWidth < 800,
      maxZoom: 20,
      minZoom: 12,
      viewport: {},
      popUpState: false
    }

    this.trackPopupClicks = this.trackPopupClicks.bind(this)
  }

  trackPopupClicks(spot) {
    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Tipp: ' + spot.name
    })
  }

  saveStartViewport = viewport => {
    if (this.startViewport === null) {
      this.startViewport = viewport
    }
  }

  getSectionBounds(section) {
    // for comparison we want all lat/lon-arrays
    // of items in current section in one flat array
    const positions = institutions
      .filter(m => {
        return sectionMembers[section].includes(m.name)
      })
      .map(i => {
        return i.positions.map(p => p.position)
      })
      .flat()

    // sort lats and longs
    const lats = []
    const longs = []
    for (const [lat, long] of positions) {
      lats.push(lat)
      longs.push(long)
    }

    // top left (North-West): biggest lat, smallest long
    const topLeft = [Math.max(...lats), Math.min(...longs)]

    // bottom right (South-Eeast): smallest lat, biggest long
    const bottomRight = [Math.min(...lats), Math.max(...longs)]

    return L.latLngBounds([topLeft, bottomRight]).pad(0.14)
  }

  render() {
    const position = [46.948895, 7.440025]

    return (
      <Map
        // eslint-disable-next-line react/jsx-handler-names
        onViewportChanged={this.saveStartViewport}
        scale={position}
        bounds={this.getSectionBounds(this.props.currentSection)} // will react to changes
        zoomControl={false}
        center={position}
        tap={false}
        maxZoom={this.state.maxZoom}
        minZoom={this.state.minZoom}
        dragging={!this.state.isMobile}
        // dragging
        touchZoom
        scrollWheelZoom={false}
        ref='leafletMap'
        zoomDelta={0.3}
        zoomSnap={0}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> Der Bund'
          url='https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
          // url='https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png'
          // url='https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png'
          // url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png'
          // url='https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png'
          // url='https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.{ext}'
          // ext='jpg'

          // https://leaflet-extras.github.io/leaflet-providers/preview/index.html
        />

        {/* SECTION CULTURE */}
        {this.props.currentSection === sections.CULTURE ? (
          <LayerGroup ref={sections.CULTURE}>
            <MapItem
              name='reitschule'
              isCurrent={this.props.currentItems === 'reitschule'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='dampfzentrale'
              isCurrent={this.props.currentItems === 'dampfzentrale'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
            <MapItem
              name='club111'
              isCurrent={this.props.currentItems === 'club111'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name='kunstkanal'
              isCurrent={this.props.currentItems === 'kunstkanal'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION ECONOMY */}
        {this.props.currentSection === sections.ECONOMY ? (
          <LayerGroup ref={sections.ECONOMY}>
            <MapItem
              name='brasserie-lorraine'
              isCurrent={this.props.currentItems === 'brasserie-lorraine'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='velokurier'
              isCurrent={this.props.currentItems === 'velokurier'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='manus'
              isCurrent={this.props.currentItems === 'manus'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='velowerkstatt'
              isCurrent={this.props.currentItems === 'velowerkstatt'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='hallerladen'
              isCurrent={this.props.currentItems === 'hallerladen'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='weltladen'
              isCurrent={this.props.currentItems === 'weltladen'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='wylereggladen'
              isCurrent={this.props.currentItems === 'wylereggladen'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='treuhandburoTis'
              isCurrent={this.props.currentItems === 'treuhandburoTis'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.EIGTH}
            />
            <MapItem
              name='vorsorgestiftungGepabu'
              isCurrent={this.props.currentItems === 'vorsorgestiftungGepabu'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION SOZIAL */}
        {this.props.currentSection === sections.SOCIAL ? (
          <LayerGroup ref={sections.SOCIAL}>
            <MapItem
              name='sleeper'
              isCurrent={this.props.currentItems === 'sleeper'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='gassenarbeit'
              isCurrent={this.props.currentItems === 'gassenarbeit'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name='fixerstubli'
              isCurrent={this.props.currentItems === 'fixerstubli'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
            <MapItem
              name='xenia'
              isCurrent={this.props.currentItems === 'xenia'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION HOUSING */}
        {this.props.currentSection === sections.HOUSING ? (
          <LayerGroup ref={sections.HOUSING}>
            <MapItem
              name='giebel'
              isCurrent={this.props.currentItems === 'giebel'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='qHof'
              isCurrent={this.props.currentItems === 'qHof'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='murifeld'
              isCurrent={this.props.currentItems === 'murifeld'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='zaffaraya'
              isCurrent={this.props.currentItems === 'zaffaraya'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='viaFelsenau'
              isCurrent={this.props.currentItems === 'viaFelsenau'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='aarestrand'
              isCurrent={this.props.currentItems === 'aarestrand'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION HOOD */}
        {this.props.currentSection === sections.HOOD ? (
          <LayerGroup ref={sections.HOOD}>
            <MapItem
              name='breitschTraff'
              isCurrent={this.props.currentItems === 'breitschTraff'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />

            <MapItem
              name='villaStucki'
              isCurrent={this.props.currentItems === 'villaStucki'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />

            <MapItem
              name='labigiLorraine'
              isCurrent={this.props.currentItems === 'labigiLorraine'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
          </LayerGroup>
        ) : null}

        {/* SECTION YOUTH */}
        {this.props.currentSection === sections.YOUTH ? (
          <LayerGroup ref={sections.YOUTH}>
            <MapItem
              name='bronx'
              isCurrent={this.props.currentItems === 'bronx'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FIRST}
            />
            <MapItem
              name='juko'
              isCurrent={this.props.currentItems === 'juko'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.SECOND}
            />
            <MapItem
              name='spielewerkstatt'
              isCurrent={this.props.currentItems === 'spielewerkstatt'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.THIRD}
            />
            <MapItem
              name='schutzenweg'
              isCurrent={this.props.currentItems === 'schutzenweg'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
            <MapItem
              name='graffiti'
              isCurrent={this.props.currentItems === 'graffiti'}
              currentPlace={this.props.currentPlace}
              updatePlace={this.props.updatePlace}
              color={colors.FOURTH}
            />
          </LayerGroup>
        ) : null}

        <ScaleControl position='bottomleft' metric imperial={false} />
        <ZoomControl position='topright' />
        <Control position='topleft' />
      </Map>
    )
  }
}
